// extracted by mini-css-extract-plugin
module.exports = {"greyBg":"App_greyBg__2L290","beigeBg":"App_beigeBg__1oxYj"};